import { Avatar } from '@mui/material'
import { TableHeaderConfigWithType } from '../../components/_EOS/Table'
import { Product, ProductImage } from './entities/Product'
import React from 'react'
import { ProductOrigin } from '../../interfaces/Producto/ProductOrigins'
import { StatusIcon } from '../../components/_WMS/StatusIcon/StatusIcon'

export const generateTableHeadersProduct = (
  productOrigins: ProductOrigin[] | undefined
) => {
  const tableHeadersProduct: TableHeaderConfigWithType<Product>[] = [
    {
      field: 'image',
      title: 'Imagen',
      sortable: false,
      formater: (image: unknown) => setImage(image as unknown)
    },
    {
      field: 'name',
      title: 'Nombre Producto',
      sortable: false
    },
    {
      field: 'sku',
      title: 'SKU',
      sortable: false
    },
    {
      field: 'ean13',
      title: 'EAN13',
      sortable: false
    },
    {
      field: 'ERPCode',
      title: 'Código ERP',
      sortable: false
    },
    {
      field: 'productOriginId',
      title: 'Origen',
      sortable: false,
      formater: (value: unknown) =>
        productOrigins?.find((el) => el.productOriginId === (value as number))
          ?.name || ''
    },
    {
      field: 'active',
      title: 'Estado',
      sortable: false,
      formater: (active: unknown) => setIconState(active as boolean)
    },
    {
      field: 'batch',
      title: 'Lote',
      sortable: false,
      formater: (value: unknown) => <StatusIcon value={Boolean(value)} />
    },
    {
      field: 'expirationDate',
      title: 'Fecha Vencimiento',
      sortable: false,
      formater: (value: unknown) => <StatusIcon value={Boolean(value)} />
    },
    {
      field: 'isGreenSale',
      title: 'Venta en Verde',
      sortable: false,
      formater: (value: unknown) => <StatusIcon value={Boolean(value)} />
    }
  ]

  return tableHeadersProduct
}

const setIconState = (active: boolean) => {
  let backgroundColor = ''
  let colorText = ''
  let text = ''

  if (active) {
    backgroundColor = '#1976d2'
    colorText = 'white'
    text = 'Activo'
  } else {
    backgroundColor = '#f48fb1'
    colorText = 'black'
    text = 'Inactivo'
  }

  return (
    <div
      style={{
        borderRadius: '20px',
        padding: '4px 12px',
        fontSize: '11px',
        marginRight: '8px',
        backgroundColor: backgroundColor,
        color: colorText
      }}
    >
      {text}
    </div>
  )
}


const setImage = (pImage: ProductImage[] | unknown) => {
  const imageAux = pImage as ProductImage[]

  const image =
    imageAux && imageAux.length > 0
      ? imageAux[0].url
      : 'https://via.placeholder.com/150/e5e5e5/808080?text=Sin%20Imagen'

  return (
    <Avatar
      style={{ height: '100px', width: '100px' }}
      variant='square'
      alt='SkuImage'
      src={image}
    />
  )
}
